export default {
  title: "Contentbeheersysteem",
  subtitle: "Beheer uw website-inhoud, activiteiten, verhalen, gidsen, recensies en instellingen",
  menu: {
    dashboard: "Dashboard",
    activities: "Activiteiten",
    stories: "Verhalen",
    guides: "Gidsen",
    team: "Team",
    reviews: "Recensies",
    contactMessages: "Contact inbox",
    faq: "Helpcentrum",
    pages: "Pagina's",
    menus: "Menu's",
    media: "Mediabibliotheek",
    settings: "Instellingen"
  },
  activities: {
    title: "Activiteiten",
    activityTitle: "Activiteitstitel",
    createNew: "Nieuwe Activiteit Aanmaken",
    createActivity: "Activiteit Aanmaken",
    editActivity: "Activiteit Bewerken",
    name: "Activiteitsnaam",
    description: "Beschrijving",
    location: "Locatie",
    duration: "Duur",
    price: "Prijs",
    category: "Categorie",
    status: "Status",
    statusOptions: {
      draft: "Concept",
      published: "Gepubliceerd",
      archived: "Gearchiveerd"
    },
    categories: {
      adventure: "Avontuur",
      cultural: "Cultureel",
      nature: "Natuur",
      relaxation: "Ontspanning",
      sports: "Sport"
    },
    emptyStateTitle: "Geen activiteiten",
    emptyStateHint: "Maak je eerste activiteit om je teamleden te inspireren.",
    searchPlaceholder: "Zoek activiteiten...",
    bsActivityLink: "Boekingssysteem Activiteitslink",
    bsActivityLinkSubtitle: "Klik hier om de setup- en builder-sectie van de activiteit te bekijken en te bewerken",
    searchBsActivity: "Zoek BS Activiteit",
    searchBsActivityPlaceholder: "Typ om te zoeken naar bestaande activiteiten...",
    basicInformation: "Basisinformatie",
    slug: "URL Slug",
    modality: "Modaliteit",
    typeOfBooking: "Type Boeking",
    startDate: "Startdatum",
    endDate: "Einddatum",
    basePrice: "Prijs vanaf (EUR)",
    basePriceSingleRoom: "Prijs vanaf in EUR (Eénpersoonskamer)",
    basePriceDoubleRoom: "Prijs vanaf in EUR (Tweepersoonskamer)",
    pricingSettings: "Prijsinstellingen",
    groupSize: "Groepsgrootte",
    difficulty: "Moeilijkheidsgraad",
    locationInformation: "Locatie-informatie",
    generalLocation: "Algemene Locatie",
    generalCountry: "Algemeen Land",
    fromLocation: "Van Locatie",
    toLocation: "Naar Locatie",
    generalAccommodation: "Algemene Accommodatie",
    travelType: "Reistype",
    map: "Kaart Embed URL",
    mapHelp: "<p><strong>Hoe Google Maps Embed URL te krijgen:</strong></p><ol><li>Ga naar <a href=\"https://maps.google.com\" target=\"_blank\">Google Maps</a></li><li>Zoek of navigeer naar de locatie die u wilt</li><li>Klik op de knop <strong>\"Delen\"</strong></li><li>Selecteer het tabblad <strong>\"Kaart insluiten\"</strong></li><li>Kopieer de iframe <strong>src</strong> URL (begint met https://www.google.com/maps/embed)</li><li>Plak het hier</li></ol><p><strong>Voorbeeld:</strong><br>https://www.google.com/maps/embed?pb=!1m18!1m12!...</p>",
    categoriesAndLanguages: "Categorieën en Talen",
    availableLanguages: "Beschikbare Talen",
    services: "Diensten",
    transfer: "Baggage Transfer",
    transport: "Transport",
    luggageTransport: "Bagagevervoer",
    transferService: "Transfer",
    serviceBookingTooltip: "Indien ingeschakeld kunnen bezoekers deze dienst aanvragen via een boekingspopup op de website.",
    viewOnWebsite: "Bekijk op website",
    previewOnWebsite: "Voorbeeld op website",
    previewMissingSlug: "Voeg eerst een slug toe voor deze taal voordat je een voorbeeld bekijkt.",
    previewLocaleUnsupported: "Websitevoorbeeld is alleen beschikbaar voor Engels en Nederlands. Wissel van taaltabblad en probeer opnieuw.",
    previewMissingSiteUrl: "Stel eerst de site-URL in bij CMS-instellingen voordat je een voorbeeld bekijkt.",
    previewUnavailable: "Sla de activiteit eerst op om een voorbeeldlink te genereren.",
    goToActivitySetup: "Ga naar activiteit setup",
    suggestedActivities: "Voorgestelde activiteiten",
    suggestedActivitiesHelp: "Andere CMS-activiteiten die als suggesties op deze activiteitspagina worden getoond.",
    overviewContent: "Overzichtsinhoud",
    overviewWebsiteHelp: "Getoond in: Overzicht op de website",
    faqWebsiteHelp: "Getoond in: Goed om te weten",
    importFromBuilder: "Importeren uit Activity Builder",
    copyFromActivity: "Kopiëren van CMS-activiteit",
    copyFromActivityTitle: "Inhoud kopiëren van een andere activiteit",
    copyFromActivityHelp: "Selecteer welke secties je wilt kopiëren van de gekozen CMS-activiteit.",
    copySections: {
      translations: "Vertalingen & SEO",
      configuration: "Configuratie",
      stages: "Reisdag etappes",
      overview: "Overzichtsinhoud",
      faq: "FAQ (Goed om te weten)",
      categories: "Categorieën",
      suggestedActivities: "Voorgestelde activiteiten"
    },
    applyCopy: "Kopie toepassen",
    stageFrom: "Van",
    stageTo: "Naar",
    stageMode: "Reismodus",
    stageDistance: "Afstand (km)",
    stageLocation: "Locatie",
    isStageDay: "Etappedag (routeonderdeel)",
    stageModeWalk: "Wandelen",
    stageModeBike: "Fietsen",
    stagesHelp: "Bewerk itinerary dagen voor de website. Ze worden initieel ingevuld vanuit de BS-activiteit maar zijn aanpasbaar.",
    addDay: "Dag toevoegen",
    reorderDay: "Sleep om te herschikken",
    stageDayLabel: "Dag {order}",
    stageDayCountOne: "{count} dag",
    stageDayCountMany: "{count} dagen",
    addFirstDay: "Eerste dag toevoegen",
    noStagesYet: "Nog geen itinerary dagen",
    noStagesHint: "Importeer vanuit de Activity Builder of voeg dagen handmatig toe.",
    stageTitlePlaceholder: "Dagtitel",
    stageImage: "Dagafbeelding",
    stageImageHelp: "Uitgelichte afbeelding voor deze dag op de website.",
    stageFeaturedImageAltHelp: "HTML alt-attribuut voor toegankelijkheid en SEO. Wordt niet als bijschrift onder de afbeelding getoond. Als dit leeg blijft, wordt de dagtitel gebruikt.",
    stageDescription: "Fasebeschrijving (WYSIWYG)",
    stageRouteHint: "Routesegment met van/naar, reismodus en afstand.",
    stageLocationHint: "Vrije locatietekst voor dagen zonder route (rustdagen, transfers, etc.).",
    expandAllDays: "Alles uitklappen",
    collapseAllDays: "Alles inklappen",
    stagesTotalDistance: "{distance} km totaal",
    stageContentSection: "Inhoud",
    stageRouteSection: "Route & locatie",
    dayTypeRoute: "Route",
    dayTypeLocation: "Locatie",
    overviewWhyChoose: "Waarom deze reis kiezen",
    overviewHighlights: "Hoogtepunten",
    overviewSuitability: "Geschiktheid",
    overviewConsiderations: "Overwegingen",
    overviewSectionLabel: "Sectielabel",
    overviewTitle: "Titel",
    overviewSubLabel: "Sub-label",
    overviewListItems: "Lijstitems",
    addListItem: "Item toevoegen",
    content: "Inhoud",
    aboutThisTrip: "Over Deze Reis",
    additionalInfo: "Aanvullende Informatie",
    extraInformation: "Extra Informatie",
    includesInformation: "Inclusief Informatie",
    includedInformation: "Inclusief Informatie",
    notIncludedInformation: "Niet Inclusief Informatie",
    addIncludedItem: "Voer inclusief item in...",
    addNotIncludedItem: "Voer niet inclusief item in...",
    addItem: "Item Toevoegen",
    guiders: "Gidsen",
    guiderName: "Gidsnaam",
    guidersHelp: "Selecteer gidsen om te associëren met deze activiteit. Maak nieuwe gidsen aan in de Gidsen-sectie.",
    guiderTagline: "Tagline",
    sinceDate: "Sinds Jaar",
    rating: "Beoordeling",
    numberOfReviews: "Aantal Recensies",
    addGuider: "Gids Toevoegen",
    reviews: "Recensies",
    reviewTitle: "Recensietitel",
    reviewerName: "Recensentnaam",
    reviewDate: "Recensiedatum",
    reviewContent: "Recensie-inhoud",
    addReview: "Recensie Toevoegen",
    stages: "Fasen",
    stage: "Fase",
    stageOrder: "Fasevolgorde",
    stageTitle: "Fasetitel",
    stageFeaturedImage: "Fase Uitgelichte Afbeelding",
    stageGallery: "Fase Galerij URL's",
    stageExtraData: "Fase Extra Gegevens",
    addExtraDataItem: "Voer extra gegevensitem in...",
    addStage: "Fase Toevoegen",
    faq: "Veelgestelde Vragen",
    faqQuestion: "Vraag",
    faqAnswer: "Antwoord (WYSIWYG)",
    addFaqItem: "Veelgestelde Vragen Item Toevoegen",
    noFaqsYet: "Nog geen veelgestelde vragen toegevoegd",
    addFirstFaqHint: "Klik op de knop hieronder om uw eerste veelgestelde vraag toe te voegen",
    faqQuestionPlaceholder: "Voer uw vraag hier in...",
    media: "Media",
    featuredImage: "Uitgelichte Afbeelding URL",
    gallery: "Galerij URL's",
    addImage: "Afbeelding Toevoegen",
    seo: "SEO",
    seoTitle: "SEO Titel",
    seoDescription: "SEO Beschrijving",
    keywords: "Trefwoorden",
    addKeyword: "Trefwoord Toevoegen",
    keywordsHelp: "Optioneel. SEO-termen voor deze taal. Lege regels worden bij opslaan genegeerd.",
    titlePlaceholder: "Voeg titel hier toe...",
    publish: "Publiceren",
    visibility: "Zichtbaarheid",
    visibilityPublic: "Zichtbaar voor iedereen",
    visibilityPrivate: "Alleen zichtbaar voor sitebeheerders",
    details: "Details",
    dates: "Data",
    searchGuiders: "Zoek Gidsen",
    searchGuidersPlaceholder: "Typ om te zoeken naar gidsen...",
    searchReviews: "Zoek Recensies",
    searchReviewsPlaceholder: "Typ om te zoeken naar recensies...",
    faqNote: "Als er geen veelgestelde vraag wordt verstrekt, wordt de standaard veelgestelde vraag weergegeven op de activiteitenpagina.",
    retrievedActivity: "Activiteit Ophalen",
    configuration: "Activiteitsconfiguratie",
    additionalCategories: "Aanvullende Categorieën",
    translations: "Vertalingen",
    isFeatured: "Uitgelichte Activiteit",
    cmsFields: "CMS Activiteitsvelden",
    createNewGuider: "Nieuwe Gids Aanmaken",
    createNewReview: "Nieuwe Recensie Aanmaken",
    noGuidersAssociated: "Geen gidsen geassocieerd met deze activiteit",
    noReviewsAssociated: "Geen recensies geassocieerd met deze activiteit",
    publishActivity: "Publiceren",
    unpublishActivity: "Depubliceren",
    publishSuccess: "Activiteit succesvol gepubliceerd",
    unpublishSuccess: "Activiteit verplaatst naar concept",
    deleteSuccess: "CMS activiteit succesvol verwijderd",
    mediaUploadRequiresCreation: "Sla de CMS activiteit op voordat u media uploadt.",
    saveFeaturedMediaButton: "Uitgelichte Afbeelding Opslaan",
    featuredImageAlt: "Alt-tekst uitgelichte afbeelding",
    featuredImageAltHelp: "Beschrijf de afbeelding voor toegankelijkheid en SEO.",
    saveGalleryMediaButton: "Galerij Opslaan",
    featuredMediaSaveSuccess: "Uitgelichte afbeelding succesvol bijgewerkt.",
    galleryMediaSaveSuccess: "Galerij succesvol bijgewerkt.",
    translationValidationError: "Vul alstublieft {fields} in voor {language}.",
    translationGenericLanguage: "deze taal",
    featuredBadge: "Uitgelicht",
    cmsActivityLabel: "CMS-activiteit",
    addToCmsActivity: "Toevoegen aan CMS",
    cmsActivityPublished: "Gepubliceerd",
    cmsActivityDraft: "Concept",
    noCategoriesAvailable: "Geen categorieën beschikbaar",
    addCategoryHint: "Gebruik de knop Toevoegen om de categoriebeheerder te openen en er een aan te maken.",
    additionalCategoriesHelp: "Kies welke categorieën bij deze activiteit horen. Namen volgen de taal in je vertaaltab.",
    categoriesSelectedSummary: "{count} geselecteerd",
    retrieveActivityNote: "Selecteer een activiteit uit het BS om te koppelen aan de website activiteit. Dit vult automatisch belangrijke informatie in.",
    loadingActivityDetails: "Activiteitsdetails laden...",
    cmsFieldsPlaceholderTitle: "Selecteer hierboven een activiteit om te beginnen met het aanpassen van inhoud, SEO-instellingen en vertalingen voor uw website.",
    multiLanguageContent: "Meertalige inhoud",
    seoOptimization: "SEO-optimalisatie",
    keywordsMetadata: "Trefwoorden en metadata",
    activityModalityHelp: "Activiteitsmodaliteit",
    durationPlaceholder: "bijv., 6 Dagen",
    durationHelp: "Duur van de activiteit (bewerkbaar)",
    accommodationPlaceholder: "bijv., 3-sterrenhotels",
    basePriceSingleRoomHelp: "Prijs vanaf voor eenpersoonskamer (EUR)",
    basePriceDoubleRoomHelp: "Prijs vanaf voor tweepersoonskamer (EUR)",
    startDateHelp: "Startdatum voor de activiteit (vereist voor groepsmodaliteit)",
    groupTripDateRanges: "Groepsreisdata",
    tripRangeLabel: "Reis {n}",
    tripRangeColTrip: "#",
    tripRangeColSingle: "Eenpers. €",
    tripRangeColDouble: "Tweepers. €",
    tripRangeColMaxPax: "Max pax",
    tripRangeColAvailable: "Vrij",
    tripRangeAvailableHint: "Beschikbare plaatsen (max minus geboekt)",
    tripRangeMaxPax: "Max deelnemers",
    tripRangeColGuiders: "Gidsen",
    groupTripDateRangesHelp: "Voeg per vertrek een rij toe. Nieuwe reizen gebruiken de basisprijzen hierboven; pas per vertrek aan indien nodig. De einddatum wordt berekend uit de duur van de activiteit.",
    tripRangeStart: "Start",
    tripRangeEnd: "Einde (auto)",
    tripRangeEndAutoHelp: "Berekend uit de duur van de activiteit ({days} dagen).",
    tripRangeEndAutoNoDuration: "Stel hierboven de duur van de activiteit in om de einddatum automatisch te berekenen.",
    tripRangeGuiders: "Gidsen voor deze reis",
    removeTripDates: "Deze reis verwijderen",
    addTripDates: "Reisdata toevoegen",
    basePriceHelp: "Prijs vanaf voor deze activiteit (EUR)",
    configurationPlaceholderDescription: "Configureer activiteitsinstellingen zoals prijzen, moeilijkheidsgraad, boekings type en meer zodra u een activiteit selecteert.",
    pricingBooking: "Prijzen en boekingen",
    locationDetails: "Locatiedetails",
    durationDates: "Duur en data",
    stagesReadOnlyNote: "⚠️ Dagelijkse reisschema-etappes van de opgehaalde activiteit (Alleen-lezen)",
    stagesNotAvailable: "🚧 Etappengegevens zijn nog niet beschikbaar",
    stagesWipMessage: "Deze sectie is in ontwikkeling. Het endpoint om etappes van de BS-activiteit op te halen wordt geïmplementeerd door de backend-ontwikkelaar.",
    dayStage: "Dag {order}: {title}",
    stagesPlaceholderNote: "Dagelijkse reisschema-etappes verschijnen hier",
    stagesPlaceholderDescription: "Bekijk en beheer de dagelijkse reisschema-etappes die automatisch worden geïmporteerd van uw geselecteerde activiteit.",
    dayByDaySchedule: "Dag-voor-dag schema",
    routeInformation: "Route-informatie",
    readOnlyContent: "Alleen-lezen inhoud",
    reviewsPlaceholderDescription: "Toon klantentestimonials en recensies om geloofwaardigheid op te bouwen en potentiële klanten te helpen beslissingen te nemen.",
    starRatings: "Sterbeoordelingen",
    customerStories: "Klantenverhalen",
    socialProof: "Sociale bewijskracht",
    associatedReviewsNote: "Geassocieerde recensies uit de Recensies-sectie",
    createReviewsHint: "Maak recensies in de Recensies-sectie om ze aan deze activiteit te koppelen",
    faqPlaceholderDescription: "Voeg veelgestelde vragen toe om bezoekers te helpen uw activiteit beter te begrijpen.",
    commonQuestions: "Veelgestelde vragen",
    quickAnswers: "Snelle antwoorden",
    customerSupport: "Klantenservice",
    mediaPlaceholderDescription: "Upload afbeeldingen om uw activiteit te tonen. De uitgelichte afbeelding wordt prominent weergegeven.",
    highQualityImages: "Afbeeldingen van hoge kwaliteit",
    gallerySupport: "Galerijondersteuning",
    visualAppeal: "Visuele aantrekkingskracht",
    recommendedSize: "Aanbevolen: 1920x1080px",
    galleryHelpText: "Voeg meerdere afbeeldingen toe aan uw activiteitsgalerij",
    pleaseSelectActivityFirst: "Selecteer eerst een activiteit",
    cmsActivityUpdatedSuccess: "CMS-activiteit succesvol bijgewerkt",
    cmsActivityCreatedSuccess: "CMS-activiteit succesvol aangemaakt",
    errorSavingCmsActivity: "Fout bij het opslaan van de CMS-activiteit. Probeer het opnieuw.",
    noActivitySelected: "Geen activiteit geselecteerd",
    draftSavedSuccess: "Concept succesvol opgeslagen",
    activityPublishedSuccess: "Activiteit succesvol gepubliceerd",
    noUploadsToConfirm: "Geen uploads om te bevestigen",
    modalityOptions: {
      selfGuided: "Zelfgeleid",
      group: "Groep"
    },
    bookingTypeOptions: {
      enquiry: "Vraag",
      booking: "Boeking",
      instant: "Direct",
      hybrid: "Hybride"
    },
    difficultyOptions: {
      easy: "Makkelijk",
      medium: "Gemiddeld",
      intermediate: "Gemiddeld",
      hard: "Moeilijk"
    },
    languageOptions: {
      en: "Engels",
      es: "Spaans",
      nl: "Nederlands"
    }
  },
  stories: {
    title: "Verhalen",
    createNew: "Nieuw Verhaal Aanmaken",
    createStory: "Verhaal Aanmaken",
    editStory: "Verhaal Bewerken",
    publishing: "Publicatie-instellingen",
    generalInfo: "Algemene Informatie",
    translationsSection: "Inhoud",
    seoSection: "SEO",
    mediaSection: "Media",
    relationshipsSection: "Relaties",
    storyTitle: "Titel",
    author: "Auteur (teamlid)",
    authorPlaceholder: "Selecteer een teamlid",
    category: "Categorie",
    categoryPlaceholder: "Selecteer een categorie",
    content: "Inhoud",
    contentShortcodeHelp: "Voeg [waw_newsletter] ergens in de inhoud in om het nieuwsbriefaanmeldformulier op de website op die plek weer te geven.",
    insertNewsletterShortcode: "Nieuwsbriefformulier invoegen",
    excerpt: "Uittreksel",
    featuredImage: "Uitgelichte Afbeelding",
    featuredImageHelp: "Aanbevolen grootte: 1920x1080px",
    featuredImageAlt: "Alt-tekst uitgelichte afbeelding",
    featuredImageAltHelp: "Beschrijf de afbeelding voor toegankelijkheid en SEO.",
    tags: "Tags",
    tagsPlaceholder: "Tag toevoegen",
    publishDate: "Publicatiedatum",
    scheduledPublish: "Publicatie plannen",
    publishedAt: "Gepubliceerd Op",
    status: "Status",
    isFeatured: "Uitgelicht Verhaal",
    isPublic: "Openbaar Verhaal",
    relatedActivities: "Gerelateerde Activiteiten",
    relatedActivitiesHelp: "Koppel dit verhaal aan CMS activiteiten om ze weer te geven als gerelateerde ervaringen.",
    faqNote: "Optioneel. Voeg veelgestelde vragen toe die op de verhalenpagina worden getoond.",
    noFaqsYet: "Nog geen veelgestelde vragen",
    addFirstFaqHint: "Klik op \"FAQ toevoegen\" om je eerste vraag en antwoord toe te voegen.",
    statusOptions: {
      draft: "Concept",
      published: "Gepubliceerd",
      scheduled: "Gepland"
    },
    filters: {
      language: "Taal",
      status: "Status",
      category: "Categorie",
      author: "Auteur",
      tag: "Tag",
      featured: "Alleen uitgelicht",
      public: "Alleen openbaar"
    },
    list: {
      emptyStateTitle: "Nog geen verhalen",
      emptyStateHint: "Maak uw eerste verhaal aan om reisinspiratie te delen."
    },
    searchPlaceholder: "Zoek verhalen...",
    slug: "Slug",
    customUrl: "Aangepaste URL",
    customUrlHelp: "De URL slug voor dit verhaal (bijv., \"mijn-verhaal\", \"reistips\"). Laat leeg om de vertaal slug te gebruiken.",
    seoTitle: "SEO Titel",
    seoDescription: "SEO Beschrijving",
    seoKeywords: "SEO Trefwoorden",
    seoKeywordsPlaceholder: "Trefwoord toevoegen",
    media: "Media",
    gallery: "Galerij",
    galleryHelp: "Voeg tot 20 afbeeldingen toe om dit verhaal te tonen.",
    uploadFeatured: "Uitgelichte Afbeelding Opslaan",
    uploadGallery: "Galerij Opslaan",
    tagsHelper: "Gebruik betekenisvolle trefwoorden om SEO te helpen",
    translations: "Vertalingen",
    translationValidationError: "Vul alstublieft {fields} in voor {language}.",
    translationGenericLanguage: "deze taal",
    relatedActivitiesPlaceholder: "Zoek CMS activiteiten...",
    publishSuccess: "Verhaal succesvol gepubliceerd",
    unpublishSuccess: "Verhaal verplaatst naar conceptstatus",
    deleteSuccess: "Verhaal succesvol verwijderd"
  },
  guides: {
    title: "Gidsen",
    createNew: "Nieuwe Gids Aanmaken",
    createGuide: "Gids Aanmaken",
    editGuide: "Gids Bewerken",
    userSelection: "Gebruikersselectie",
    user: "Gebruiker",
    userPlaceholder: "Selecteer een gebruiker (optioneel)",
    generalInfo: "Algemene Informatie",
    additionalInfo: "Aanvullende Informatie",
    relationshipsSection: "Relaties",
    guideTitle: "Titel",
    slug: "Slug",
    bio: "Biografie",
    tagline: "Tagline",
    content: "Inhoud",
    memberSince: "Lid Sinds",
    memberSinceHelp: "Datum waarop de gids lid werd",
    relatedActivities: "Gerelateerde Activiteiten",
    relatedActivitiesHelp: "Koppel deze gids aan CMS activiteiten om ze weer te geven als gerelateerde ervaringen.",
    relatedActivitiesPlaceholder: "Zoek CMS activiteiten...",
    mediaSection: "Media",
    featuredImage: "Uitgelichte Afbeelding",
    featuredImageHelp: "Aanbevolen grootte: 1920x1080px",
    featuredImageAlt: "Alt-tekst uitgelichte afbeelding",
    featuredImageAltHelp: "Beschrijf de afbeelding voor toegankelijkheid en SEO.",
    uploadFeatured: "Uitgelichte Afbeelding Opslaan",
    publishing: "Publicatie",
    isPublic: "Openbaar",
    isFeatured: "Uitgelicht",
    isAuthor: "Auteur",
    seoTitle: "SEO Titel",
    seoDescription: "SEO Beschrijving",
    seoKeywords: "SEO Trefwoorden",
    seoKeywordsPlaceholder: "Trefwoorden toevoegen...",
    description: "Beschrijving",
    destination: "Bestemming",
    category: "Categorie",
    difficulty: "Moeilijkheidsgraad",
    duration: "Geschatte Duur",
    status: "Status",
    statusOptions: {
      draft: "Concept",
      published: "Gepubliceerd",
      archived: "Gearchiveerd"
    },
    difficultyLevels: {
      easy: "Makkelijk",
      moderate: "Matig",
      difficult: "Moeilijk",
      expert: "Expert"
    },
    searchPlaceholder: "Zoek gidsen...",
    filters: {
      language: "Taal"
    },
    list: {
      emptyStateTitle: "Nog geen gidsen",
      emptyStateHint: "Maak uw eerste gids aan om uw teamleden te presenteren."
    },
    publishSuccess: "Gids succesvol gepubliceerd",
    unpublishSuccess: "Gids verplaatst naar conceptstatus",
    deleteSuccess: "Gids succesvol verwijderd"
  },
  team: {
    title: "Team",
    createNew: "Teamlid aanmaken",
    createMember: "Teamlid aanmaken",
    editMember: "Teamlid bewerken",
    generalInfo: "Algemene informatie",
    translationsSection: "Vertalingen",
    name: "Naam",
    role: "Rol",
    bio: "Bio",
    facts: "Leuke weetjes",
    factQuestion: "Vraag",
    factAnswer: "Antwoord",
    addFact: "Weetje toevoegen",
    order: "Volgorde",
    orderHelp: "Lagere nummers verschijnen eerst op de over-ons pagina",
    linkedGuider: "Gekoppelde gids (optioneel)",
    linkedGuiderPlaceholder: "Selecteer een gidsprofiel",
    linkedin: "LinkedIn-profiel URL",
    linkedinPlaceholder: "https://www.linkedin.com/in/gebruikersnaam",
    instagram: "Instagram-profiel URL",
    instagramPlaceholder: "https://www.instagram.com/gebruikersnaam",
    noLinkedGuider: "Geen",
    mediaSection: "Media",
    featuredImage: "Foto",
    featuredImageHelp: "Aanbevolen formaat: portretverhouding",
    featuredImageAlt: "Alt-tekst foto",
    uploadFeatured: "Foto opslaan",
    publishing: "Publiceren",
    isPublic: "Openbaar",
    searchPlaceholder: "Zoek teamleden...",
    translationValidationError: "Vul minstens één volledige vertaling in (naam en bio).",
    filters: {
      language: "Taal"
    },
    list: {
      emptyStateTitle: "Nog geen teamleden",
      emptyStateHint: "Voeg teamleden toe om ze op de over-ons pagina te tonen."
    },
    publishSuccess: "Teamlid gepubliceerd",
    unpublishSuccess: "Teamlid naar concept verplaatst",
    deleteSuccess: "Teamlid verwijderd"
  },
  reviews: {
    title: "Recensies",
    createNew: "Nieuwe Recensie Aanmaken",
    createReview: "Recensie Aanmaken",
    editReview: "Recensie Bewerken",
    generalInfo: "Algemene Informatie",
    additionalInfo: "Aanvullende Informatie",
    relationshipsSection: "Relaties",
    mediaSection: "Media",
    reviewTitle: "Titel",
    author: "Auteursnaam",
    rating: "Beoordeling",
    content: "Recensie-inhoud",
    activity: "Gerelateerde Activiteit",
    activityPlaceholder: "Selecteer een activiteit (optioneel)",
    activityHelp: "Laat leeg voor algemene recensies, of selecteer een activiteit om deze recensie te associëren.",
    date: "Recensiedatum",
    status: "Status",
    statusOptions: {
      pending: "In Afwachting",
      approved: "Goedgekeurd",
      rejected: "Afgewezen"
    },
    ratings: {
      1: "1 Ster",
      2: "2 Sterren",
      3: "3 Sterren",
      4: "4 Sterren",
      5: "5 Sterren"
    },
    featuredImage: "Uitgelichte Afbeelding",
    featuredImageHelp: "Aanbevolen grootte: 1920x1080px",
    featuredImageAlt: "Alt-tekst uitgelichte afbeelding",
    featuredImageAltHelp: "Beschrijf de afbeelding voor toegankelijkheid en SEO.",
    uploadFeatured: "Uitgelichte Afbeelding Opslaan",
    searchPlaceholder: "Zoek recensies...",
    filters: {
      language: "Taal",
      activity: "Activiteit",
      rating: "Beoordeling",
      status: "Status"
    },
    list: {
      emptyStateTitle: "Nog geen recensies",
      emptyStateHint: "Maak uw eerste recensie aan om feedback te verzamelen."
    },
    publishSuccess: "Recensie succesvol gepubliceerd",
    unpublishSuccess: "Recensie verplaatst naar conceptstatus",
    deleteSuccess: "Recensie succesvol verwijderd",
    authorName: "Naam auteur",
    authorEmail: "E-mail auteur",
    statuses: {
      pending: "In afwachting",
      approved: "Goedgekeurd",
      rejected: "Afgewezen"
    },
    approve: "Goedkeuren",
    reject: "Afwijzen",
    statusUpdateSuccess: "Status succesvol bijgewerkt"
  },
  contactMessages: {
    title: "Contact inbox",
    subtitle: "Berichten via het contactformulier op de website.",
    searchPlaceholder: "Zoek op naam, e-mail of bericht…",
    topic: "Onderwerp",
    message: "Bericht",
    from: "Van",
    locale: "Taal",
    receivedAt: "Ontvangen",
    reference: "Referentie",
    viewMessage: "Bericht bekijken",
    markRead: "Markeer als gelezen",
    markNew: "Markeer als ongelezen",
    archive: "Archiveren",
    restore: "Terug naar inbox",
    replyViaEmail: "Antwoord via e-mail",
    statusUpdateSuccess: "Status bijgewerkt",
    deleteSuccess: "Bericht verwijderd",
    selectTitle: "Selecteer een bericht",
    selectHint: "Kies een bericht uit de lijst om te lezen en te beantwoorden.",
    messageCount: "{count} berichten",
    topics: {
      booking: "Boeking of betaling",
      trip: "Vraag over een reis",
      custom: "Maatwerk of privéreis",
      other: "Iets anders",
      general: "Algemeen"
    },
    statuses: {
      new: "Nieuw",
      read: "Gelezen",
      archived: "Gearchiveerd"
    },
    filters: {
      status: "Status",
      topic: "Onderwerp"
    },
    list: {
      emptyStateTitle: "Nog geen contactberichten",
      emptyStateHint: "Inzendingen via het contactformulier op de website verschijnen hier."
    }
  },
  faq: {
    title: "Helpcentrum",
    createNew: "Nieuw Artikel Aanmaken",
    createFaq: "Artikel Aanmaken",
    editFaq: "Artikel Bewerken",
    createCategory: "Categorie Aanmaken",
    articleTitle: "Artikeltitel",
    generalInfo: "Algemene Informatie",
    contentSection: "Inhoud",
    faqSection: "Veelgestelde Vragen Items",
    question: "Vraag",
    answer: "Antwoord",
    category: "Categorie",
    addFaqItem: "Veelgestelde Vragen Item Toevoegen",
    addFaqToCategory: "Veelgestelde Vragen aan Categorie Toevoegen",
    manageFaqs: "Veelgestelde Vragen Beheren",
    removeFaqItem: "Veelgestelde Vragen Item Verwijderen",
    order: "Weergavevolgorde",
    status: "Status",
    statusOptions: {
      draft: "Concept",
      published: "Gepubliceerd",
      archived: "Gearchiveerd"
    },
    categories: {
      general: "Algemeen",
      booking: "Boeking",
      travel: "Reizen",
      activities: "Activiteiten",
      payment: "Betaling"
    },
    searchPlaceholder: "Zoek artikelen...",
    filters: {
      language: "Taal",
      category: "Categorie"
    },
    list: {
      emptyStateTitle: "Nog geen artikelen",
      emptyStateHint: "Maak uw eerste helpcentrum artikel aan om uw gebruikers te helpen."
    },
    publishSuccess: "Artikel succesvol gepubliceerd",
    unpublishSuccess: "Artikel verplaatst naar conceptstatus",
    deleteSuccess: "Categorie succesvol verwijderd",
    faq: "Veelgestelde Vraag",
    faqs: "Veelgestelde Vragen",
    categoryName: "Categorie"
  },
  settings: {
    title: "Instellingen",
    save: "Instellingen Opslaan",
    general: {
      title: "Algemene Instellingen",
      siteName: "Sitenaam",
      siteDescription: "Sitebeschrijving",
      siteUrl: "Site URL",
      siteNamePlaceholder: "Voer sitenaam in",
      siteDescriptionPlaceholder: "Voer een korte beschrijving van uw site in",
      siteUrlPlaceholder: "https://voorbeeld.com"
    },
    contact: {
      title: "Contactinformatie",
      email: "Contact E-mail",
      phone: "Contact Telefoon",
      address: "Adres",
      city: "Stad",
      postalCode: "Postcode",
      country: "Land",
      emailPlaceholder: "contact@voorbeeld.com",
      phonePlaceholder: "+1 234 567 8900",
      addressPlaceholder: "Straatadres",
      cityPlaceholder: "Stad",
      postalCodePlaceholder: "Postcode",
      countryPlaceholder: "Land"
    },
    social: {
      title: "Social Media Links",
      facebook: "Facebook URL",
      instagram: "Instagram URL",
      twitter: "Twitter URL",
      linkedin: "LinkedIn URL",
      youtube: "YouTube URL",
      facebookPlaceholder: "https://facebook.com/jouwpagina",
      instagramPlaceholder: "https://instagram.com/jouwpagina",
      twitterPlaceholder: "https://twitter.com/jouwpagina",
      linkedinPlaceholder: "https://linkedin.com/bedrijf/jouwpagina",
      youtubePlaceholder: "https://youtube.com/kanaal/jouwkanaal"
    },
    hero: {
      title: "Hero-media",
      mediaType: "Mediatype",
      none: "Geen media",
      image: "Afbeelding",
      video: "Geuploade video",
      youtube: "YouTube-video",
      youtubeUrl: "YouTube-URL",
      imageUpload: "Hero-afbeelding",
      videoUpload: "Hero-video",
      videoRecommendedSpec: "Aanbevolen: 1920x1080 (16:9), lus van 6-15 sec, MP4 H.264, 1,5-4 MB.",
      videoMobileImageHint: "Op mobiel en smalle schermen (768 px en smaller) toont de website de hero-afbeelding in plaats van de video. Upload hieronder een fallback-afbeelding voor mobiele bezoekers.",
      mobileImageUpload: "Hero-afbeelding voor mobiel (fallback)",
      textMode: "Modus zichtbaarheid tekst",
      textModeAuto: "Automatische leesbaarheid",
      textModeManual: "Handmatige bediening",
      textVisible: "Hero-tekst tonen (handmatige modus)",
      overlayEnabled: "Donkere overlay inschakelen",
      overlayOpacity: "Overlaydekking (0-100)"
    },
    appearance: {
      title: "Uiterlijk",
      primaryColor: "Primaire Kleur",
      secondaryColor: "Secundaire Kleur",
      logo: "Logo",
      uploadLogo: "Logo Uploaden",
      changeLogo: "Logo Wijzigen",
      favicon: "Favicon",
      changeFavicon: "Favicon Wijzigen",
      defaultLogo: "Standaard logo wordt gebruikt als er geen wordt geüpload",
      defaultFavicon: "Standaard favicon wordt gebruikt als er geen wordt geüpload",
      defaultAppearance: "Standaard uiterlijk instellingen worden gebruikt als er geen worden geconfigureerd",
      uploaded: "Geüpload",
      primaryColorPlaceholder: "#667eea",
      secondaryColorPlaceholder: "#764ba2"
    },
    tripAvailability: {
      title: "Berichten beschikbaarheid reizen",
      threshold: "Drempel lage beschikbaarheid",
      thresholdHelp: "Toon het urgentiebericht wanneer dit aantal plaatsen of minder over is.",
      lowStockEn: "Bericht lage beschikbaarheid (Engels)",
      lowStockNl: "Bericht lage beschikbaarheid (Nederlands)",
      soldOutEn: "Uitverkocht-bericht (Engels)",
      soldOutNl: "Uitverkocht-bericht (Nederlands)",
      unavailableEn: "Bericht onvoldoende plaatsen (Engels)",
      unavailableNl: "Bericht onvoldoende plaatsen (Nederlands)",
      placeholderCount: "Gebruik {count} voor resterende plaatsen"
    },
    maintenance: {
      title: "Onderhoud",
      enabled: "Onderhoudsmodus inschakelen op de publieke website",
      statusOn: "Onderhoud is AAN",
      statusOff: "Onderhoud is UIT",
      warning: "Wanneer ingeschakeld zien bezoekers alleen de pagina in aanbouw. Zoekmachines ontvangen 503 en robots.txt blokkeert crawlen.",
      titleEn: "Kop (Engels)",
      titleNl: "Kop (Nederlands)",
      messageEn: "Bericht (Engels)",
      messageNl: "Bericht (Nederlands)",
      bypassTitle: "Voorbeeld-bypass",
      bypassHint: "Gebruik ?maintenance_bypass=TOKEN op de website om de live site te bekijken terwijl onderhoud voor anderen aan blijft.",
      bypassToken: "Bypass-token",
      copyToken: "Kopiëren",
      regenerateToken: "Opnieuw genereren",
      envHint: "Stel ook MAINTENANCE_BYPASS_TOKEN op de website-server in op dezelfde waarde zodat de bypass werkt.",
      noToken: "Nog geen bypass-token. Sla op of genereer er een.",
      tokenCopied: "Bypass-token gekopieerd",
      tokenRegenerated: "Bypass-token opnieuw gegenereerd",
      previewWebsite: "Website bekijken",
      regenerateConfirmTitle: "Bypass-token opnieuw genereren?",
      regenerateConfirmMessage: "Je huidige token gaat met pensioen op een boerderij. Je moet ook MAINTENANCE_BYPASS_TOKEN in je website-env bijwerken — tenzij je verrassings-lockouts leuk vindt. Was die klik echt de bedoeling?",
      regenerateConfirmButton: "Ja, opnieuw genereren",
      regenerateCancelButton: "Laat maar, ik hou van mijn token"
    }
  },
  dashboard: {
    title: "Dashboard",
    subtitle: "Overzicht van je CMS-inhoud",
    quickGoto: "Snel naar",
    quickGotoHint: "Ga direct naar de secties die je het meest gebruikt.",
    greetingMorning: "Goedemorgen",
    greetingAfternoon: "Goedemiddag",
    greetingEvening: "Goedenavond",
    heroSummary: "Je beheert momenteel {count} contentitems op de site.",
    publishRate: "Live",
    contentMix: "Contentmix",
    contentMixHint: "Aandeel van je catalogus per sectie, gesorteerd van groot naar klein.",
    healthTitle: "Live-dekking",
    healthHint: "Hoeveel van elke sectie al openbaar is.",
    liveOfTotal: "{live} van {total} live",
    items: "Items",
    people: "Mensen",
    attention: {
      maintenanceTitle: "Onderhoudsmodus staat aan",
      maintenanceMeta: "Bezoekers zien de pagina in aanbouw. Beheer de instellingen.",
      reviewsTitle: "{count} recensies wachten",
      reviewsMeta: "Keur recensies van bezoekers goed of af.",
      inboxTitle: "{count} nieuwe berichten",
      inboxMeta: "Open de contactinbox om te antwoorden."
    },
    stats: {
      activities: "Activiteiten",
      stories: "Verhalen",
      pages: "Pagina's",
      reviews: "Recensies",
      contactMessages: "Contactberichten",
      guiders: "Gidsen",
      teamMembers: "Teamleden",
      public: "Openbaar",
      pending: "In afwachting",
      new: "Nieuw"
    },
    maintenance: {
      title: "Website-onderhoud",
      on: "Aan",
      off: "Uit",
      manage: "Beheren"
    }
  },
  pages: {
    title: "Pagina's",
    createNew: "Nieuwe Pagina Aanmaken",
    createPage: "Pagina Aanmaken",
    editPage: "Pagina Bewerken",
    status: "Status",
    pageType: "Paginatype",
    customUrl: "Aangepaste URL",
    customUrlHelp: "De URL slug voor deze taal (bijv., \"over-ons\", \"about-us\"). Elke taal kan een eigen URL hebben.",
    pageTypeOptions: {
      custom: "Aangepast",
      about: "Over Ons",
      terms: "Algemene Voorwaarden",
      privacy: "Privacybeleid"
    },
    statusOptions: {
      draft: "Concept",
      published: "Gepubliceerd"
    },
    searchPlaceholder: "Zoek pagina's...",
    filters: {
      public: "Alleen Openbaar"
    },
    list: {
      emptyStateTitle: "Nog geen pagina's",
      emptyStateHint: "Maak uw eerste pagina aan om de inhoud van uw website te bouwen."
    },
    publishSuccess: "Pagina succesvol gepubliceerd",
    unpublishSuccess: "Pagina verplaatst naar conceptstatus",
    deleteSuccess: "Pagina succesvol verwijderd",
    isFeatured: "Uitgelichte Pagina",
    translationsSection: "Vertalingen",
    pageTitle: "Paginatitel",
    content: "Inhoud",
    seoTitle: "SEO Titel",
    seoDescription: "SEO Beschrijving",
    seoKeywords: "SEO Trefwoorden",
    seoKeywordsPlaceholder: "Trefwoord toevoegen",
    generalInfo: "Algemene Informatie",
    order: "Volgorde",
    orderHelp: "Weergavevolgorde voor sorteren",
    relationshipsSection: "Relaties",
    relatedActivities: "Gerelateerde Activiteiten",
    relatedActivitiesHelp: "Koppel CMS activiteiten om weer te geven op deze pagina",
    relatedActivitiesPlaceholder: "Zoek CMS activiteiten...",
    mediaSection: "Media",
    featuredImage: "Uitgelichte Afbeelding",
    featuredImageHelp: "Aanbevolen grootte: 1920x1080px",
    featuredImageAlt: "Alt-tekst uitgelichte afbeelding",
    featuredImageAltHelp: "Beschrijf de afbeelding voor toegankelijkheid en SEO.",
    uploadFeatured: "Uitgelichte Afbeelding Opslaan"
  },
  menus: {
    title: "Menu's",
    createNew: "Nieuw Menu-item Aanmaken",
    createMenu: "Menu-item Aanmaken",
    editMenu: "Menu-item Bewerken",
    generalInfo: "Algemene Informatie",
    publishing: "Publicatie",
    menuLabel: "Menulabel",
    menuType: "Menutype",
    menuTypeOptions: {
      page: "Pagina",
      link: "Externe Link",
      category: "Categorie",
      activity: "Activiteit"
    },
    parentMenu: "Bovenliggend Menu",
    parentMenuPlaceholder: "Selecteer bovenliggend menu (optioneel)",
    parentMenuHelp: "Laat leeg voor menu-items op het hoogste niveau",
    pageLink: "Pagina",
    pageLinkPlaceholder: "Selecteer een pagina",
    activityLink: "Activiteit",
    activityLinkPlaceholder: "Selecteer een activiteit",
    activityRequired: "Selecteer alstublieft een activiteit",
    externalUrl: "Externe URL",
    externalUrlPlaceholder: "https://voorbeeld.com",
    categorySlug: "Categorie Slug",
    categorySlugPlaceholder: "categorie-slug",
    order: "Volgorde",
    orderHelp: "Weergavevolgorde in menu",
    status: "Status",
    statusOptions: {
      draft: "Concept",
      published: "Gepubliceerd"
    },
    searchPlaceholder: "Zoek menu-items...",
    filters: {
      public: "Alleen Openbaar"
    },
    list: {
      emptyStateTitle: "Nog geen menu-items",
      emptyStateHint: "Maak uw eerste menu-item aan om uw navigatie te bouwen."
    },
    publishSuccess: "Menu-item succesvol gepubliceerd",
    unpublishSuccess: "Menu-item verplaatst naar conceptstatus",
    deleteSuccess: "Menu-item succesvol verwijderd",
    reorderSuccess: "Menu-items succesvol herordend",
    failedToLoadActivities: "Fout bij het laden van activiteiten",
    noActivitiesFound: "Geen activiteiten gevonden",
    translationsSection: "Vertalingen",
    menuLabelHelp: "De tekst die in het menu wordt weergegeven",
    translationValidationError: "Vul alstublieft alle vereiste velden in",
    pageRequired: "Selecteer alstublieft een pagina",
    externalUrlRequired: "Voer alstublieft een externe URL in",
    categorySlugRequired: "Voer alstublieft een categorie slug in",
    expandAll: "Alles Uitklappen",
    collapseAll: "Alles Inklappen"
  },
  activityCategories: {
    title: "Activiteitscategorieën",
    addNew: "Nieuwe Categorie Toevoegen",
    existingCategories: "Bestaande Categorieën",
    noCategories: "Geen categorieën gevonden. Maak uw eerste categorie hierboven aan.",
    manageCategories: "Categorieën Beheren",
    slug: "Slug",
    slugPlaceholder: "bijv., wandelen, fietsen, hiken",
    name: "Naam",
    order: "Volgorde",
    icon: "Pictogram",
    uploadIcon: "Pictogram Uploaden",
    iconHelp: "Upload een SVG-pictogram voor deze categorie (aanbevolen: 48x48px)",
    isPublic: "Openbaar",
    createSuccess: "Categorie succesvol aangemaakt",
    updateSuccess: "Categorie succesvol bijgewerkt",
    deleteSuccess: "Categorie succesvol verwijderd",
    editCategory: "Categorie Bewerken",
    reset: "Resetten"
  },
  storyCategories: {
    title: "Verhaalcategorieën",
    addNew: "Nieuwe Categorie Toevoegen",
    existingCategories: "Bestaande Categorieën",
    noCategories: "Geen categorieën gevonden. Maak uw eerste categorie hierboven aan.",
    type: "Type",
    types: {
      destination: "Bestemming",
      topic: "Onderwerp"
    },
    parent: "Bovenliggende Categorie",
    rootCategory: "— Root (geen bovenliggende)",
    slug: "Slug",
    slugPlaceholder: "bijv., camino-frances, mallorca",
    name: "Naam",
    order: "Volgorde",
    isPublic: "Openbaar",
    editCategory: "Categorie Bewerken",
    createSuccess: "Categorie succesvol aangemaakt",
    updateSuccess: "Categorie succesvol bijgewerkt",
    deleteSuccess: "Categorie succesvol verwijderd",
    reset: "Resetten"
  },
  media: "Media"
};
